import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppraisalRoutingModule } from './appraisal-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppilicationListComponent } from './application/appilication-list/appilication-list.component';
import { AppilicationCrudComponent } from './application/appilication-crud/appilication-crud.component';
import { ApprovalListComponent } from './approval-list/approval-list.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { EvaluationListComponent } from './evaluation/evaluation-list/evaluation-list.component';
import { AppraisalCycleComponent } from './appraisal-cycle/appraisal-cycle/appraisal-cycle.component';
import { AppraisalCycleCrudComponent } from './appraisal-cycle/appraisal-cycle-crud/appraisal-cycle-crud.component';
import { ManageApprovalComponent } from './approval/manage-approval/manage-approval.component';
import { ApprovalRatingsComponent } from './approval/manage-approval/approval-ratings/approval-ratings.component';
import { ApprovalPerformanceComponent } from './approval/manage-approval/approval-performance/approval-performance.component';
import { ApprovalMatrixComponent } from './approval/manage-approval/approval-matrix/approval-matrix.component';
import { ApprovalComponent } from './approval/approval/approval.component';
import { ManageEvaluationComponent } from './evaluation/manage-evaluation/manage-evaluation.component';
import { ApprovalHikeComponent } from './approval/manage-approval/approval-hike/approval-hike.component';
import { ApprovalPromotableComponent } from './approval/manage-approval/approval-promotable/approval-promotable.component';
import { ApprovalCommentComponent } from './approval/manage-approval/approval-comment/approval-comment.component';
import { EvaluationReportComponent } from './evaluation/evaluation-report/evaluation-report.component';
import { EvaluationSlipComponent } from './evaluation/evaluation-slip/evaluation-slip.component';


@NgModule({
  declarations: [
    AppilicationListComponent,
    AppilicationCrudComponent,
    ApprovalListComponent,
    EvaluationListComponent,
    AppraisalCycleComponent,
    AppraisalCycleCrudComponent,
    ManageApprovalComponent,
    ApprovalRatingsComponent,
    ApprovalPerformanceComponent,
    ApprovalMatrixComponent,
    ApprovalComponent,
    ManageEvaluationComponent,
    ApprovalHikeComponent,
    ApprovalPromotableComponent,
    ApprovalCommentComponent,
    EvaluationReportComponent,
    EvaluationSlipComponent,   
    
  ],
  imports: [
    CommonModule,
    AppraisalRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ]
})
export class AppraisalModule { }
